<template>
  <div class="flex flex-col h-64 mx-8 my-16 text-center">
    <div
      class="inline-block h-32 text-6xl font-bold text-white"
      ref="name-and-title"
    >
      NOAH KUMPF
    </div>
    <Carousel />
  </div>
</template>

<script>
import Carousel from "./Carousel.vue";

export default {
  components: {
    Carousel,
  },
};
</script>
